let { config } = initialState;

function guid() {
	function p8(s) {
		const p = `${Math.random().toString(16)}000000000`.substr(2, 8);
		return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
	}
	return p8() + p8(true) + p8(true) + p8();
}

if (localStorage.getItem("session_key") === null) {
	localStorage.setItem("session_key", guid());
}

config = JSON.parse(config);

if (window.location.href.toString().indexOf("dev.") !== -1) {
	config.cdns = ["//cdn.dev.juegosjuegos.com/"];
} else {
	config.cdns = ["//cdn.pomu.com/"];
}

config.session_key = localStorage.getItem("session_key");
config.supports_webp = false;

config.videoPlayableTutorial =
	typeof localStorage.getItem("videoPlayableTutorial") == null ||
	localStorage.getItem("videoPlayableTutorial") <= 2;
config.dfpHandler = function() {};
config.ads = {};
config.dfpReloadAds = window.watchAds || {};

export default (state = config, action) => {
	switch (action.type) {
		case "GAME_PLAYABLETUTORIAL":
			localStorage.setItem(
				"videoPlayableTutorial",
				localStorage.getItem("videoPlayableTutorial") + 1
			);
			return Object.assign({}, state, {
				...state,
				videoPlayableTutorial: false
			});
		case "UPDATE_ADBLOCK":
			if (typeof action.payload.cb === "function") {
				action.payload.cb(action.payload.adBlock);
			}
			return Object.assign({}, state, {
				...state,
				adBlock: action.payload.adBlock
			});
		case "ADS_SET_BLOCKS":
			return Object.assign({}, state, {
				...state,
				ads: { ...action.payload.data }
			});
		case "ONLOAD_EVENT":
			return Object.assign({}, state, {
				...state,
				loaded: action.payload.loaded
			});
		case "STOP_SHAKING":
			return Object.assign({}, state, {
				...state,
				shaking: false
			});
		case "UPDATE_SECTION":
			document
				.getElementsByTagName("body")[0]
				.setAttribute("data-section", action.payload.data);
			document
				.getElementsByTagName("html")[0]
				.setAttribute("data-section", action.payload.data);
			return Object.assign({}, state, {
				...state,
				section: action.payload.data,
				shaking: true
			});
		case "SET_FUNCTION":
			return Object.assign({}, state, {
				...state,
				[action.payload.name]: action.payload.func
			});
		case "DFPHANDLER_SET":
			console.log("[A]DFPHANDLER_SET");
			return Object.assign({}, state, {
				...state,
				dfpHandler: { ...action.payload.handler }
			});
		case "UPDATE_WEBPSUPPORT":
			return Object.assign({}, state, {
				...state,
				supports_webp: action.payload.data
			});
		case "UPDATE_ISRETINA":
			return Object.assign({}, state, {
				...state,
				is_retina: action.payload.data
			});
		default:
			return state;
	}
};
